export const menuIcons = {
    //  sports: 'pi pi-fw pi-check-square',
}
